import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import '../styles/Home.css';
import Background from '../img/banner.jpeg';
import { LeadingLawPublications, AuthorSpotlight, HomeLatestUpdates, Search } from './Home/index';
import Dropdown from 'react-bootstrap/Dropdown';
import { appService } from '../_services';
import ReactGA from 'react-ga';
var sectionStyle = {
    backgroundImage: "url(" + Background + ")"
};

let useragent = navigator.userAgent;

export class Home extends Component {
    displayName = Home.name
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            Journals: [],
            Manuals: [],
            Encyclopedias: [],
            LatestUpdates: [],
            LatestPubList: [],
            AuthorLst: [],
            mktCampaign: []
        };
    }

    componentDidMount() {

        if (localStorage.getItem('user') !== null && localStorage.getItem('salesForceID') !== null) {
            window.location.href = "/LoginHome";
        }
        var self = this;
        
        appService.getAll('Home/GetHomePageDataAll')
            .then(function (homedata) {
                //if (homedata.shouldReload == "true") {
                //    window.location.reload(false);
                //}
               // console.log(homedata);
                if (homedata.isErrorExist == true) {
                    //window.location = "/Maintenance";;
                }
                self.setState({ items: homedata });
                self.setState({ Journals: homedata.listJournal });
                self.setState({ Manuals: homedata.listManual });
                self.setState({ Encyclopedias: homedata.listEncyclopedia });
                self.setState({ LatestUpdates: homedata.listLatestUpdates });
                self.setState({ AuthorLst: homedata.listAuthor });
                self.setState({ mktCampaign: homedata.mktCampaign });
               
            });

        if (localStorage.getItem('user') !== null) {
            window['NTPT_PGEXTRA'] = '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }
        else {
            window['NTPT_PGEXTRA'] = 'platform=klo';
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }

        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Home");
        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
    }
    updateForAuthor(author) {
        this.props.appAuthorCallBack(author);
    }

    render() {
        const meta = {
            title: "Kluwer Law Online - Home",
            canonical: window.location.href,
        }
        return (
            <DocumentMeta {...meta}>
                <div className="col-12">
                    <div className="row" id="flex-container">
                        <div className="col-lg-8">
                            <div className="col BgWhite">
                                <h2 className="Newheader">Introducing some of our leading law publications</h2>
                                <br></br>
                            </div>
                            <div className="col BgWhite">
                                <LeadingLawPublications
                                    journalList={this.state.Journals}
                                    encyclopediaList={this.state.Encyclopedias}
                                    manualList={this.state.Manuals}
                                />
                            </div>

                            <div className="col-lg-12 margintop BgWhite">
                                <h2 className="Newheader">Author Spotlight</h2>
                                <AuthorSpotlight HomeCallbackAuthor={this.updateForAuthor.bind(this)} AuthorList={this.state.AuthorLst} />
                            </div>
                        </div>
                        <div className="col-lg-4 BgWhite Rescls">
                            <h2 className="Updateheader">Latest updates</h2>
                            <br></br>
                            <HomeLatestUpdates LatestUpdatesList={this.state.LatestUpdates} />
                        </div>
                    </div>
                    <div className="Grey"></div>
                </div>
                </DocumentMeta>
               
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Home.jsx